export default "__VITE_ASSET__DsU5Wl9M__"